<template>
  <d-modal
    size="lg"
    :class="{ 'is-hidden': isHidden }"
    @close="handleClose">
    <d-modal-header class="mb-4">Lista zadłużonych klientów</d-modal-header>
    <d-modal-body class="px-0 py-0">
      <clients-list
        :inPopup="true" />
    </d-modal-body>
  </d-modal>
</template>

<script>
import ClientsList from './../../views/Clients.vue';

export default {
  name: 'product-variant-popup',
  components: {
    'clients-list': ClientsList
  },
  data() {
    return {
      isHidden: true,
    };
  },
  mounted() {
    this.$bus.$on('show-clients-in-debt-popup', this.openPopup);
  },
  methods: {
    handleClose() {
      this.isHidden = true;
    },
    openPopup() {
      setTimeout(() => {
        this.isHidden = false;
      }, 0);
    },
    cancel() {
      this.handleClose();
    },
    closePopup() {
      this.isHidden = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}
</style>
